import CardActionButtonList from './CardActionButtonList';
import { LINK } from '../constants/CardActionDisplayMode';
import { CARD_ACTION_FORMATTER_IFRAME_LOOKUP_KEYS } from '../constants/IframeLookupKeys';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LinkCardActionButtonList({
  actionConfigs
}) {
  return /*#__PURE__*/_jsx(CardActionButtonList, {
    actionConfigs: actionConfigs,
    mode: LINK
  });
}
LinkCardActionButtonList.iframeLookupKey = CARD_ACTION_FORMATTER_IFRAME_LOOKUP_KEYS.LINK_CARD_ACTION_BUTTON_LIST;